export const questions = [
    {
        id: 1, 
        question:"Is Toggl Track free for an unlimited number of users?",
        answer: "Toggl Track is free for teams of up to 5 members."
    },
    {
        id: 2, 
        question:"How is the subscription fee calculated for paid plans?",
        answer: "You will be charged a monthly fee for each member of your team. For paid plans, this fee applies even if you have under 5 active users. You will not be charged for deactivated users. If you deactivate a user, all data associated with the deactivated user will be retained."
    },
    {
        id: 3, 
        question:"Does Toggl Track have desktop or mobile apps? Are they free?" ,
        answer: "Yes, we’re on desktop and mobile. We have desktop apps for Windows and macOS, and mobile apps for iOS and Android. All of our apps are free to download and use."
    },
    {
        id: 4, 
        question:"Does Toggl Track track GPS and take screenshots?" ,
        answer: "Toggl Track stands against employee surveillance and micromanagement. Monitoring has never been a feature in our software nor our culture—and it never will be. Toggl Track is not for managers who are trying to snoop. We will never have features for screen recording, location tracking, keystroke tracking, or webcam monitoring. We don't spy on our employees here at Toggl Track, and we think you shouldn't either.Read more about why we don't believe in surveillance here.",
    },
    {
        id: 5, 
        question: "What tools does Toggl Track integrate with?",
        answer: "Toggl Track has over 100+ integrations. Our Chrome and Safari browser extensions allow you to start the timer directly from online tools like Asana, Todoist, Trello, and more. The browser extensions come with features such as the Pomodoro Timer, idle detection, and tracking reminders—it’s the ultimate tool to help you stay focused on work."
    },
   
]